export default "__VITE_ASSET__Okq8xpfe__"